import { Component, EventEmitter, Input, Output } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-theme-color-selector',
  templateUrl: './theme-color-selector.component.html',
  styleUrls: ['./theme-color-selector.component.scss']
})
export class ThemeColorSelectorComponent {
  @Input() public colors;
  @Output() public updateColors: EventEmitter<string[]> = new EventEmitter();

  public updatingColors = false;

  public setColor(col, idx) {
    this.updatingColors = true;
    this.colors[idx] = col;
  }

  public cancelConfigureColors() {
    this.updatingColors = false;
    this.colors = Object.values(environment.wiki.colors);
  }

  public configureColors() {
    this.updatingColors = false;
    return this.updateColors.emit(this.colors);
  }
}
